import ClientStore from "../Store/ClientStore";

export const nurseCGRelation = () => {
  const nurseData = [];
  const careGiverData = [];
  ClientStore.clientEmployeeRelationData.forEach((item) => {
    const formattedItem = {
      value: item.id,
      label: `${item.firstName} ${item.lastName}`,
    };
    if (item.employeeCategory === "Nurse") {
      nurseData.push(formattedItem);
    } else if (item.employeeCategory === "CareGiver") {
      careGiverData.push(formattedItem);
    }
  });
  return [nurseData, careGiverData];
};
